import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/a86deecd-f696-40a0-8c97-89ac1f059358";
export const REGISTER_URL = "https://a.ntrk2.com/2094d589-77fa-423e-a3db-37b756e45471";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://wowbr.loadprkw2a.com/download?openExternalBrowser=1&id=pnrhxhn71r8oo3g";

export * from "./codes";
export * from "./context";
